// extracted by mini-css-extract-plugin
export default {"title":"GlifosCategoryTreeView_title__+FyxC","description":"GlifosCategoryTreeView_description__2DR9x","categories":"GlifosCategoryTreeView_categories__SchW3"};